import { FormControl, FormLabel } from '@chakra-ui/react';
import { customersApi } from '@texas/api/endpoints/customersApi';
import { CreateUserRequest } from '@texas/api/endpoints/userApi';
import { useApiResource } from '@texas/api/hooks/useApiResource';
import { ReactSelectOption } from '@texas/types';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Control, useController } from 'react-hook-form';
import { TexasSelect } from '../shared/form/TexasSelect';

interface CustomerAssignmentFieldProps {
  control: Control<CreateUserRequest>;
}

export function CustomerAssignmentField({
  control,
}: CustomerAssignmentFieldProps) {
  const { t } = useTranslation();
  const [searchInput, setSearchInput] = useState('');
  const { field } = useController({
    name: 'customerId',
    control,
    shouldUnregister: true,
  });
  const {
    data: customers,
    refetch,
    loading,
  } = useApiResource(customersApi.getAll);

  useEffect(() => {
    refetch();
  }, [refetch]);

  const options = (customers ?? []).map<ReactSelectOption>((customer) => ({
    value: customer.id,
    label: customer.name,
  }));

  return (
    <FormControl>
      <FormLabel>{t('general.brand')}</FormLabel>
      <TexasSelect
        {...field}
        required={true}
        isLoading={loading}
        placeholder={t('concept.searchBrand')}
        value={options.find((option) => option.value === field.value)}
        onChange={(option) => field.onChange(option ? option.value : null)}
        onInputChange={setSearchInput}
        options={searchInput.length === 0 ? [] : options}
      />
    </FormControl>
  );
}
